import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    let navigate = useNavigate();
    const routeRegister = () => {
        let path = '/register';
        navigate(path);
    };
    const routeLogin = () => {
        let path = '/login';
        navigate(path);
    };

    return (
        <header className="navbar">
            <div className="navbar-content">
                <h2 className="mb-0">Finspace</h2>
            </div>
            <nav className="navbar-content-logged-out">
                <button
                    type="button"
                    className="btn button-secondary navbar-button"
                    onClick={routeLogin}
                >
                    Log In
                </button>
                <button
                    type="button"
                    className="btn button-primary navbar-button"
                    onClick={routeRegister}
                >
                    Request Access
                </button>
            </nav>
        </header>
    );
};

export default Navbar;
